<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (projectStateService.isAreaPlannerProject()) {
    <button (click)="startAreaPlannerDesign()" [disabled]="!historyService.isEditModeEnabled" windeGreen>Start Design</button>
} @else {
    @if (historyService.isEditModeEnabled) {
        <div class="form-check item_row">
            <label class="form-check-label" for="isMultipleDesign">
                <input
                    [(ngModel)]="projectUserSessionService.isAutoRepeatDesign"
                    [disabled]="!historyService.isEditModeEnabled"
                    class="form-check-input is-multiple-check"
                    id="isMultipleDesign"
                    name="isMultipleDesign"
                    type="checkbox"
                />
                Auto-Repeat Design
            </label>
        </div>
        <button (click)="startAutoPlan()" [disabled]="!historyService.isEditModeEnabled" windeGreen class="btn-start-design">
            Start Design
        </button>
    } @else if (projectStateService.isPotentiallyCorruptedProject()) {
        <button (click)="startMigration()" class="btn btn-start-migration btn-sm item_row">Migration Required</button>
    }

    @if (historyService.isEditModeEnabled) {
        <button
            [disabled]="!historyService.isEditModeEnabled"
            [replaceUrl]="true"
            [routerLink]="['/', { outlets: { popup: 'project-view/advanced-plan-config' } }]"
            class="btn btn-link btn-sm btn-design-config item_row"
            windeTransparent
        >
            <sui-svg-icon icon="cog" windeGrey />
            Design Settings
        </button>

        <button
            [disabled]="!historyService.isEditModeEnabled"
            [replaceUrl]="true"
            [routerLink]="['/', { outlets: { popup: 'project-view/manual-design' } }]"
            class="btn btn-link btn-sm btn-design-config item_row"
            windeTransparent
        >
            <sui-svg-icon icon="cogs" windeGrey />
            Manual design
        </button>
    }

    <button
        (click)="openDesignResults()"
        *ngIf="
            historyService.logicalTopology.designIterationsChartData && historyService.logicalTopology.designIterationsChartData.length > 0
        "
        [disabled]="!historyService.isEditModeEnabled"
        class="btn btn-link btn-sm btn-design-results item_row"
        windeTransparent
    >
        <sui-svg-icon icon="chart" windeGrey />
        Show Design Results
    </button>
}

<div class="form-check item_row">
    <label class="form-check-label">
        <input
            (change)="historyService.logicalTopology.redrawTopologyLines()"
            [(ngModel)]="projectUserSessionService.isShowLinksAndVerifiedLoses"
            class="form-check-input is-show-los"
            type="checkbox"
        />
        Show LOS Lines
    </label>
</div>

@if (!projectStateService.isAreaPlannerProject()) {
    <div class="item_row">
        <div class="sectors-show-label">Show sectors:</div>
        <div class="sectors-show-mode">
            <div class="form-check--all">
                <label class="form-check-label">
                    <input
                        (change)="showSectors()"
                        [(ngModel)]="projectUserSessionService.isShowSectors"
                        [indeterminate]="historyService.logicalTopology.getNodeNamesSectorsToShow()?.length"
                        class="form-check-input is-show-sectors"
                        type="checkbox"
                    />
                    Active
                </label>
            </div>
            <div class="form-check--active">
                <label class="form-check-label">
                    <input
                        (change)="showAllSectors()"
                        [(ngModel)]="projectUserSessionService.isShowAllSectors"
                        class="form-check-input is-show-sectors"
                        type="checkbox"
                    />
                    All
                </label>
            </div>
        </div>
    </div>

    <div class="form-check item_row">
        <label class="form-check-label">
            <input
                (change)="historyService.logicalTopology.changeSectorsLinksColor()"
                [(ngModel)]="projectUserSessionService.isUseEngineColors"
                class="form-check-input colored-sectors"
                type="checkbox"
            />
            Colored sectors and links
        </label>
    </div>
}
